//
//
//
//
//
//
//
//
//
import { DEMO_LOG_AJAX } from '@/api/demo.js';
export default {
  methods: {
    handleClick: function handleClick() {
      DEMO_LOG_AJAX();
    }
  }
};